module.exports = function(options) {

    let element;
    const _this = this;
    const events = require("../helpers/events");
    const cookie = require("../helpers/cookie");
    const ajax = require("../helpers/ajax");
    const cookieName = options.cookie || '';

    this.getElement = function () {
        return element;
    };

    this.logPreferenceChange = function(value) {
        return ajax.post(options.logUrl.replace(':value', value));
    };

    this.disableToggle = function() {
        const inputs = element.querySelectorAll('input');
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].readOnly = true;
        }
    };

    this.toggleHeader = function(event) {

        if (this.readOnly) {
            return false;
        }

        const selectedValue = this.value;

        element.classList[this.value === '1' ? 'add' : 'remove']('enabled');

        cookie.set(cookieName, selectedValue, 36500, '.adwantedconnected.com');

        _this.disableToggle();
        _this.logPreferenceChange(selectedValue).then(function() {
            switch (selectedValue) {
                case '1':
                    location.href = options.homeUrl + "/connected-app";
                    break;
                case '2':
                    if (location.pathname === '/connected-app') {
                        location.href = options.homeUrl;
                    } else {
                        location.reload();
                    }
                    break;
            }
        });
    };

    this.init = function(id) {
        element = document.getElementById(id);

        if (!element) {
            return;
        }

        events.addEvent(element, "change", function (event) {
            events.delegateEvents.call(this, event, {
                "input": _this.toggleHeader
            });
        });
    }
}
